const PopinRetraite = {
  args: {
    priseEnCompte: true,
    equation: true,
    titrePopin: 'Comment est calculée la performance sur votre contrat retraite ?',
    label: "J'ai compris",
    titreExplicationPopin: 'EXPLICATIONS',
    explicationPopin:
      'La performance calculée correspond à la valeur de l’encours majorée des montants rachetés depuis l’origine du contrat, le tout rapporté aux montants versés depuis l’ouverture du contrat.',
    titreExplication1: 'PRISE EN COMPTE DES VERSEMENTS ET RACHATS',
    explication1:
      'Les performances peuvent être temporairement erronées après un nouveau versement ou rachat. Le délai de prise en compte est en moyenne de 2 jours après la date indiquée sur le mouvement.',
    titreExplication2: 'CLAUSE DE NON-RESPONSABILITÉ',
    explication2:
      'Il est possible que certaines informations soient  différentes de celles qui vous sont communiquées directement par l’assureur (car la donnée n’est pas encore à jour ou la définition n’est pas la même).',
    paragraphe: 'Dans tous les cas, les données contractuelles sont celles qui vous sont communiquées par l’assureur.',
    titrePerformance: 'PERFORMANCE (%) =',
    numerateurEquation: 'Valorisation à date  + somme des rachats',
    denominateurEquation: 'Somme des versements',
  },
};
const PopinAssuranceVie = {
  args: {
    priseEnCompte: true,
    equation: true,
    titrePopin: 'Comment est calculée la performance sur votre assurance-vie ?',
    label: "J'ai compris",
    titreExplicationPopin: 'EXPLICATIONS',
    explicationPopin:
      'La performance calculée correspond à la valeur de l’encours majorée des montants rachetés depuis l’origine du contrat, le tout rapporté aux montants versés depuis l’ouverture du contrat.',
    titreExplication1: 'PRISE EN COMPTE DES VERSEMENTS ET RACHATS',
    explication1:
      'Les performances peuvent être temporairement erronées après un nouveau versement ou rachat. Le délai de prise en compte est en moyenne de 2 jours après la date indiquée sur le mouvement.',
    titreExplication2: 'CLAUSE DE NON-RESPONSABILITÉ',
    explication2:
      'Il est possible que certaines informations soient  différentes de celles qui vous sont communiquées directement par l’assureur (car la donnée n’est pas encore à jour ou la définition n’est pas la même).',
    paragraphe: 'Dans tous les cas, les données contractuelles sont celles qui vous sont communiquées par l’assureur.',
    titrePerformance: 'PERFORMANCE (%) =',
    numerateurEquation: 'Valorisation à date  + somme des rachats',
    denominateurEquation: 'Somme des versements',
  },
};

const PopinLivret = {
  args: {
    priseEnCompte: true,
    equation: true,

    titrePopin: 'Comment est calculée la performance sur votre livret ?',
    label: "J'ai compris",
    titreExplicationPopin: 'EXPLICATIONS',
    explicationPopin:
      'La performance calculée correspond à la valeur de l’encours majorée des retraits réalisés depuis l’origine du contrat, le tout rapporté aux montants versés depuis l’ouverture du contrat.',
    titreExplication1: 'LES INTÉRÊTS À VENIR',
    explication1:
      'Les intérêts à venir correspondent à la somme des intérêts calculés du 1er janvier jusqu’à la dernière quinzaine. \n Sauf rachat anticipé en cours d’année, les intérêts sont versés le 31 décembre.\n Les intérêts sont soumis à des prélèvements fiscaux et sociaux sauf cas d’exonération.',
    titreExplication2: 'CLAUSE DE NON-RESPONSABILITÉ',
    explication2:
      'Il est possible que certaines informations soient  différentes de celles qui vous sont communiquées directement par CFCAL-banque (car la donnée n’est pas encore à jour ou la définition n’est pas la même).',
    paragraphe:
      'Dans tous les cas, les données contractuelles sont celles qui vous sont communiquées par CFCAL-banque.',
    titrePerformance: 'PERFORMANCE (%) =',
    numerateurEquation: 'Valorisation à date  + somme des rachats',
    denominateurEquation: 'Somme des versements',
    paragrapheSousEquation:
      'Les intérêts étant versés le 31 décembre de chaque année, la performance affichée sera de zéro avant cette date (pour la première année d’ouverture uniquement).',
  },
};

const PopinDefisc = {
  args: {
    equation: true,
    PMV: true,
    titrePopin: 'Comment est calculée la performance sur votre défiscalisation ?',
    label: "J'ai compris",
    explicationPopin:
      'La performance calculée correspond à la valeur de l’encours majorée des montants remboursés, le tout rapporté au montant investi initialement.\n',
    titreExplication2: 'PRISE EN COMPTE DES VALORISATIONS ET REMBOURSEMENTS',
    titrePerformance: 'PERFORMANCE (%) =',
    numerateurEquation: 'PMV avec avantage fiscal',
    denominateurEquation: 'Versement initial',
    paragraphe:
      'Les performances sont calculées sur la dernière valorisation connue. Elles peuvent être temporairement erronées lorsqu’une évolution de la valorisation ou un remboursement sont en cours.',
    explication1: '',
    priseEnCompte: true,
  },
};

export { PopinRetraite, PopinAssuranceVie, PopinLivret, PopinDefisc };
